import { createContext, useContext } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/player/popup-group-context.tsx
const PopupGroupContext = createContext(void 0);
function PopupGroupProvider({ value, children }) {
	return /* @__PURE__ */ jsx(PopupGroupContext.Provider, {
		value,
		children
	});
}
function useOptionalPopupGroup() {
	return useContext(PopupGroupContext);
}
//#endregion
export { PopupGroupProvider, useOptionalPopupGroup };

//# sourceMappingURL=popup-group-context.js.map